/**
 * Inline product recommendations functionality
 * Fetches and displays related/complementary products in carousel format
 * Used in cart, product pages, and other areas for cross-selling
 */

(async () => {

  if (!customElements.get('product-recommendations-inline')) {

    const { default: Swiper } = await import("swiper");
    class ProductRecommendationsInline extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper-recommended-products-inline]');

        this.swiperOptions = {
          loop: false,
          autoplay: false,
          direction: 'horizontal',
          spaceBetween: 16,
          breakpoints: {
            320: {
              slidesPerView: 2
            },
            768: {
              slidesPerView: 3
            }
          }
        }

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            }
          }
        }

        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

        window.addEventListener("load", () => {
            this.getRecommendations();
        });
       
      }

      getRecommendations() {
        if (this.dataset && this.dataset.url) {
          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const source = html.querySelector('[data-recommended-products-inline]');
              const target = document.querySelector('#product-recommendations-inline');

              if (source && source.innerHTML && source.innerHTML.trim().length) {
                
                target.innerHTML = source.innerHTML;

                let swiperInnerHtml = source.querySelector('.swiper-wrapper').innerHTML.trim();

                
                if (swiperInnerHtml.length) {
                  document.querySelector('cart-items')?.querySelector('.haircoach')?.classList.remove('hidden');
                  document.querySelector('cart-add-popup')?.querySelector('.haircoach')?.classList.remove('hidden');
                }
              }
              this.swiperInstance.update();
            })
            .catch(e => {
              console.error('Error fetching recommendations:', e); // Debugging line
            });
        }
      }
    }

    window.ProductRecommendationsInline = ProductRecommendationsInline;

    customElements.define('product-recommendations-inline', ProductRecommendationsInline);

  }

})();


document.addEventListener("DOMContentLoaded", (event) => {
  const productRecommendationsSection = document.querySelector('#product-recommendations-inline');
  let productId = productRecommendationsSection.dataset.productId;

  fetch(window.Shopify.routes.root + `recommendations/products?product_id=` + productId + `&limit=3&section_id=product-recommendations-inline&intent=complementary`)
  .then(response => response.text())
  .then((text) => {
      const html = document.createElement('div');
      html.innerHTML = text;

      const recommendations = html.querySelector('.product-recommendations-inline');

      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
      }
  });
});